"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Body = exports.Indicator = exports.Icon = exports.TabButton = exports.ListTabs = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ListTabs = _styledComponents["default"].div.withConfig({
  displayName: "Tabsstyle__ListTabs",
  componentId: "dogafa-0"
})(function () {
  return {
    display: 'flex',
    position: 'relative'
  };
});

exports.ListTabs = ListTabs;

var TabButton = _styledComponents["default"].button.withConfig({
  displayName: "Tabsstyle__TabButton",
  componentId: "dogafa-1"
})(function (_ref) {
  var theme = _ref.theme,
      active = _ref['aria-selected'];
  return _extends({
    transition: '0.2s color',
    flex: '1 1 0px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    outline: 'none',
    background: 'transparent',
    border: 'none',
    padding: "".concat(theme.spacing.inline['3xs'], " ").concat(theme.spacing.inline['6xs']),
    color: active ? theme.color.brandPrimary.light : theme.color.neutral['03']
  }, (0, _utils.getTextStyle)({
    theme: theme,
    variant: 'body02-md',
    margin: false
  }), {
    svg: {
      transition: '0.2s fill',
      fill: active ? theme.color.brandPrimary.light : theme.color.neutral['03']
    },
    ':hover, :active': {
      color: theme.color.brandPrimary.light,
      svg: {
        fill: 'currentColor'
      }
    }
  });
});

exports.TabButton = TabButton;

var Icon = _styledComponents["default"].svg.withConfig({
  displayName: "Tabsstyle__Icon",
  componentId: "dogafa-2"
})(function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    display: 'block',
    width: 24,
    height: 24,
    marginBottom: spacing.inline['4xs']
  };
});

exports.Icon = Icon;

var Indicator = _styledComponents["default"].span.withConfig({
  displayName: "Tabsstyle__Indicator",
  componentId: "dogafa-3"
})(function (_ref3) {
  var color = _ref3.theme.color,
      tabLength = _ref3.tabLength,
      activeTab = _ref3.activeTab;
  return {
    transition: '0.3s transform',
    background: color.brandPrimary.light,
    borderRadius: '10px 10px 0 0',
    height: 3,
    display: 'block',
    position: 'absolute',
    bottom: 0,
    width: "".concat(1 * 100 / tabLength, "%"),
    transform: "translateX(".concat(activeTab * 100, "%)")
  };
});

exports.Indicator = Indicator;

var Body = _styledComponents["default"].div.withConfig({
  displayName: "Tabsstyle__Body",
  componentId: "dogafa-4"
})(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      color = _ref4$theme.color,
      spacing = _ref4$theme.spacing;
  return {
    borderTop: "1px solid ".concat(color.line.medium),
    paddingTop: spacing.inline.lg
  };
});

exports.Body = Body;